import { IconCircleDashedPlus } from "@tabler/icons-react";
import { PricingBoxes } from "./PricingBoxes";
import {
  Button,
  Container,
  Group,
  Paper,
  Title,
  Text,
} from "@mantine/core";
import { useStore } from "../store";

export default function PricingPage() {
  const profile = useStore((state) => state.profile);

  return (
    <Container size="md">
      <PricingBoxes currentPlan={profile.plan} />

      <Paper mt="xl" shadow="sm" radius="md" p="md" withBorder>
        <Group>
          <IconCircleDashedPlus />
          <Title order={3}>Custom Plan</Title>
          <Group wrap="wrap">
            <div miw={280} style={{ flex: 1 }}>
              <Text fw={600}>Agency / Multi-Brand / Marketplace Solutions</Text>
              <br />
              Want to track more than 3 brands? Require SSO? Get in touch for a
              custom plan tailored to your requirements!
            </div>

            <Button component="a" href="mailto:sales@getbrandkarma.com">
              Get in touch
            </Button>
          </Group>
        </Group>
      </Paper>

      <Group mt="xl">
        <Text>
          {profile.plan
            ? `Your current plan: ${profile.plan}`
            : "You are not currently on any plan."}
        </Text>
      </Group>
      {/* <Title mt="xl" order={2} ta="center" mb="xl">
        Estimate Your ROI
      </Title> */}

      {/* <RoiCalculator /> */}
    </Container>
  );
}
